import script from "./SummaryPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./SummaryPreview.vue?vue&type=script&setup=true&lang=js"

import "./SummaryPreview.vue?vue&type=style&index=0&id=19775842&lang=scss&scoped=true"
import "./SummaryPreview.vue?vue&type=style&index=1&id=19775842&lang=scss"

import exportComponent from "/Users/zsrb/Documents/中山日报/2025/zsrb-news-detail/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19775842"]])

export default __exports__